import { useState, useEffect } from "react";
import { Box, Card, Typography } from "@mui/material";
import CustomTable from "../../components/ui/CustomTable";
import { useIntl } from "react-intl";

export default function ToGo(props) {
  const intl = useIntl();
  const [detailsColumns, setDetailsColumns] = useState([]);

  const handleColumns = () => {
    var newColumns = [];
    props.detailsColumns.map((x) => {
      if (x.field != "actionsDelete") {
        newColumns.push(x);
      }
      
      setDetailsColumns(newColumns);
    });
  };

  useEffect(() => {
    handleColumns();
  }, []);

  return (
    <CustomTable
      columns={detailsColumns}
      rows={props.detailsRows}
      id={"rowNumber"}
      rowHeight={40}
      headerHeight={30}
      tableHeight={props.tableHeigth}
    />
  );
}
